import { Link, useLocation } from 'react-router-dom'
import {
  FINANCIAL_GROUP_LABELS as GROUP_LABELS,
  FINANCIAL_GROUP_ORDER as GROUP_ORDER,
  FINANCIAL_ROUTE_CONFIG,
  getFinancialGroup,
} from '../../config/financialRoutes'

export default function FinancialSectionNav() {
  const location = useLocation()
  const currentPath = location.pathname.replace(/\/+$/, '') || '/financial'
  const activeGroup = getFinancialGroup(currentPath)
  const groupItems = FINANCIAL_ROUTE_CONFIG.filter(
    (route) => route.group === activeGroup && route.id !== 'overview',
  )

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2">
        {GROUP_ORDER.map((group) => {
          const firstItem = FINANCIAL_ROUTE_CONFIG.find(
            (route) => route.group === group && route.id !== 'overview',
          )

          if (!firstItem) return null

          const isActive = group === activeGroup

          return (
            <Link
              key={group}
              to={firstItem.path}
              className={`inline-flex items-center rounded-full border px-3 py-1.5 text-sm font-medium transition-colors ${
                isActive
                  ? 'border-primary-500 bg-primary-50 text-primary-700'
                  : 'border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:text-gray-900'
              }`}
            >
              {GROUP_LABELS[group]}
            </Link>
          )
        })}
      </div>

      {/* The pages inside the active group, as tabs under the group pills. The
          active pill already names the group, so it is not repeated here. */}
      <nav aria-label={GROUP_LABELS[activeGroup]} className="flex flex-wrap gap-x-1 border-b border-gray-200">
        {groupItems.map((route) => {
          const isActive = currentPath === route.path || currentPath.startsWith(`${route.path}/`)

          return (
            <Link
              key={route.path}
              to={route.path}
              aria-current={isActive ? 'page' : undefined}
              className={`-mb-px inline-flex items-center border-b-2 px-3 py-2 text-sm font-medium transition-colors ${
                isActive
                  ? 'border-primary-600 text-primary-700'
                  : 'border-transparent text-gray-600 hover:border-gray-300 hover:text-gray-900'
              }`}
            >
              {route.label}
            </Link>
          )
        })}
      </nav>
    </div>
  )
}
